export const formConstants = {
    SET_ANSWERS: "SET_ANSWERS",
  };
  